// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseProgramCaseTypeModel {
    static getAttributeTypeMap() {
        return CaseProgramCaseTypeModel.attributeTypeMap;
    }
}
CaseProgramCaseTypeModel.discriminator = undefined;
CaseProgramCaseTypeModel.additionalProperties = false;
CaseProgramCaseTypeModel.attributeTypeMap = [
    {
        "name": "programCaseTypeId",
        "baseName": "programCaseTypeId",
        "type": "number"
    },
    {
        "name": "caseTypeId",
        "baseName": "caseTypeId",
        "type": "number"
    },
    {
        "name": "caseTypeCode",
        "baseName": "caseTypeCode",
        "type": "string"
    },
    {
        "name": "caseTypeDescription",
        "baseName": "caseTypeDescription",
        "type": "string"
    },
    {
        "name": "caseTypeCategoryId",
        "baseName": "caseTypeCategoryId",
        "type": "number"
    },
    {
        "name": "caseTypeCategoryCode",
        "baseName": "caseTypeCategoryCode",
        "type": "string"
    },
    {
        "name": "caseTypeCategoryDescription",
        "baseName": "caseTypeCategoryDescription",
        "type": "string"
    },
    {
        "name": "createdFromIntake",
        "baseName": "createdFromIntake",
        "type": "boolean"
    },
    {
        "name": "isWorkflowCase",
        "baseName": "isWorkflowCase",
        "type": "boolean"
    },
    {
        "name": "isWorkflow",
        "baseName": "isWorkflow",
        "type": "boolean"
    },
    {
        "name": "expirationPeriod",
        "baseName": "expirationPeriod",
        "type": "number"
    },
    {
        "name": "isHidden",
        "baseName": "isHidden",
        "type": "boolean"
    },
];
//# sourceMappingURL=caseProgramCaseTypeModel.js.map